/**
 * CSS Classes and Styles Constants
 * Centralized styling to reduce duplication
 */

// Common CSS Classes
export const CSS_CLASSES = {
  // Card base classes
  CARD_BASE: "p-4 rounded-xl border transition-all duration-300",
  CARD_HOVER: "hover:scale-105 hover:shadow-xl",
  CARD_CLICKABLE: "cursor-pointer",
  
  // Layout classes
  GRID_RESPONSIVE: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
  GRID_RESPONSIVE_4: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4",
  FLEX_CENTER: "flex items-center justify-center",
  FLEX_BETWEEN: "flex items-center justify-between",
  FLEX_START: "flex items-center space-x-3",
  
  // Spacing classes
  SPACE_Y_4: "space-y-4",
  SPACE_Y_6: "space-y-6",
  SPACE_Y_8: "space-y-8",
  
  // Text classes
  TEXT_PRIMARY: "text-sm font-medium",
  TEXT_SECONDARY: "text-xs",
  TEXT_LARGE: "text-lg font-bold",
  TEXT_SMALL: "text-sm",
  
  // Button classes
  BUTTON_PRIMARY: "px-6 py-3 rounded-lg font-medium transition-all duration-200",
  BUTTON_SECONDARY: "px-4 py-2 rounded-lg font-medium transition-all duration-200",
  
  // Icon classes
  ICON_CONTAINER: "p-2 rounded-lg",
  ICON_SMALL: "h-4 w-4",
  ICON_MEDIUM: "h-5 w-5",
  ICON_LARGE: "h-6 w-6",
} as const;

// Common CSS Styles
export const CSS_STYLES = {
  // Card styles
  CARD: {
    backgroundColor: 'var(--bg-card)',
    borderColor: 'var(--border-primary)',
    boxShadow: 'var(--shadow-md)'
  },
  
  CARD_SECONDARY: {
    backgroundColor: 'var(--bg-secondary)',
    borderColor: 'var(--border-primary)',
    boxShadow: 'var(--shadow-sm)'
  },
  
  CARD_TERTIARY: {
    backgroundColor: 'var(--bg-tertiary)',
    borderColor: 'var(--border-primary)',
    boxShadow: 'var(--shadow-sm)'
  },
  
  // Text colors
  TEXT_PRIMARY: {
    color: 'var(--text-primary)'
  },
  
  TEXT_SECONDARY: {
    color: 'var(--text-secondary)'
  },
  
  TEXT_TERTIARY: {
    color: 'var(--text-tertiary)'
  },
  
  // Button styles
  BUTTON_PRIMARY: {
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    border: 'none'
  },
  
  BUTTON_SECONDARY: {
    backgroundColor: 'var(--bg-secondary)',
    color: 'var(--text-primary)',
    border: '1px solid var(--border-primary)'
  }
} as const;

// Animation presets
export const ANIMATIONS = {
  FADE_IN: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.3 }
  },
  
  FADE_IN_DELAYED: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { delay: 0.2, duration: 0.3 }
  },
  
  SCALE_IN: {
    initial: { opacity: 0, scale: 0.9 },
    animate: { opacity: 1, scale: 1 },
    transition: { duration: 0.3 }
  },
  
  HOVER_LIFT: {
    whileHover: { y: -5, scale: 1.02 }
  },
  
  HOVER_SCALE: {
    whileHover: { scale: 1.05 }
  }
} as const;
